import { getRandomColor } from "@utils/getRandomColor";
import {
  EQUIPMENT_TYPE,
  EQUIPMENT_TYPES,
  ActionEquipmentBase,
  IWorkEquipment,
  IAvailableEquipment,
} from "./actionTypes";
import { helpers } from "./helpers";

const MOCK1: IAvailableEquipment[] = [
  {
    id: "1",
    name: "TP-Link Router",
    type: EQUIPMENT_TYPE.NETWORK,
    color: getRandomColor(),
  },
  {
    id: "2",
    name: "Mikrotik Router",
    type: EQUIPMENT_TYPE.NETWORK,
    color: getRandomColor(),
  },
];
const MOCK2: IWorkEquipment[] = [
  {
    id: "12",
    name: "TP-Link Router",
    color: "rgb(255, 122, 0)",
    type: EQUIPMENT_TYPE.NETWORK,
    num: 1,
  },
  {
    id: "23",
    name: "Capacity 22",
    color: "rgb(143, 0, 255)",
    type: EQUIPMENT_TYPE.ELECTRICAL,
    num: 22,
  },
];

export interface IState {
  availableEquipment: IAvailableEquipment[];
  workEquipment: IWorkEquipment[];
}

const initial: IState = {
  availableEquipment: [],
  workEquipment: [],
};

const reducer = (state = initial, action: ActionEquipmentBase): IState => {
  const { set, edit, create, deleteEq } = helpers(
    state,
    (action as any).payload
  );

  switch (action.type) {
    case EQUIPMENT_TYPES.SET_AVAILABLE_EQUIPMENT:
      return set("availableEquipment");
    case EQUIPMENT_TYPES.CREATE_AVAILABLE_EQUIPMENT:
      return create("availableEquipment");
    case EQUIPMENT_TYPES.EDIT_AVAILABLE_EQUIPMENT:
      return edit("availableEquipment");
    case EQUIPMENT_TYPES.DELETE_AVAILABLE_EQUIPMENT:
      return deleteEq("availableEquipment");
    //
    case EQUIPMENT_TYPES.SET_WORK_EQUIPMENT:
      return set("workEquipment");
    case EQUIPMENT_TYPES.ADD_WORK_EQUIPMENT:
      return create("workEquipment");
    case EQUIPMENT_TYPES.EDIT_WORK_EQUIPMENT:
      return edit("workEquipment");
    case EQUIPMENT_TYPES.DELETE_WORK_EQUIPMENT:
      return deleteEq("workEquipment");

    default:
      return state;
  }
};

export default reducer;
